// 商行详情 — 小票打印:销售单模板编辑
import React, { PureComponent } from 'react';
import qs from 'qs';
// Switch 尚未在 @/components 中封装，沿用 antd-v5 开关。
import { Input, Space, Switch, message, Spin } from 'antd-v5';
import { Button } from '@/components';
import PageHeaderLayout from '../../../../component/page-header-layout/index';
import { getAuthorityUserInfo } from '../../../../utils/authority';
import {
  requestThermalPrinterOrderTemplateEdit,
  requestThermalPrinterOrderTemplateView,
} from '../../../../state/request/tag';
import ThermalPrinterFieldChip, {
  ThermalPrinterNumberInput,
  ThermalPrinterTableHeadEditor,
} from './ThermalPrinterFieldChip';
import {
  ORDER_END_FIELDS,
  ORDER_HEAD_FIELDS,
  ORDER_PRODUCT_FIELDS,
  ORDER_TOTAL_FIELDS,
  STALL_THERMAL_PRINTER_TAB_KEY,
  cloneTemplate,
  getFieldStyle,
  getOperatorIdFromUser,
  normalizeOrderTemplate,
  updateFieldList,
} from './thermalPrinterTemplateShared';
import '../detail.less';
import './thermalPrinterTemplate.less';

const CUSTOM_CONTENT_MAX = 200;
const SALES_STYLE_DEFS = [
  { key: 'text_print', label: '文本打印' },
  { key: 'custom_style', label: '文本表格打印' },
];
const ORDER_TEXT_PRIMARY_FONT_LINKED_KEYS = ['productName', 'subtotal'];
const ORDER_TEXT_SECONDARY_FONT_LINKED_KEYS = [
  'packWeight',
  'orderNumber',
  'saleNumber',
  'grossWeight',
  'unitPrice',
  'goodsAmount',
  'extraAmount',
];
const ORDER_VISIBLE_PRODUCT_FIELDS = ORDER_PRODUCT_FIELDS.filter(
  (field) => field.key !== 'iceWeight',
);
const TABLE_LIMITED_PRODUCT_FIELD_KEYS = [
  'productName',
  'packWeight',
  'orderNumber',
  'saleNumber',
  'unitPrice',
  'goodsAmount',
  'subtotal',
];
const MAX_TABLE_LIMITED_PRODUCT_FIELDS = 6;
const ORDER_TABLE_FONT_LINKED_KEYS = [
  'productName',
  'packWeight',
  'orderNumber',
  'saleNumber',
  'unitPrice',
  'goodsAmount',
  'subtotal',
];

function getOrderProductFontLinkedKeys(isTextPrint, key) {
  if (!isTextPrint) return ORDER_TABLE_FONT_LINKED_KEYS;
  if (ORDER_TEXT_PRIMARY_FONT_LINKED_KEYS.includes(key)) {
    return ORDER_TEXT_PRIMARY_FONT_LINKED_KEYS;
  }
  if (ORDER_TEXT_SECONDARY_FONT_LINKED_KEYS.includes(key)) {
    return ORDER_TEXT_SECONDARY_FONT_LINKED_KEYS;
  }
  return [];
}

const ORDER_SAMPLE = {
  voucherName: '赊欠凭证',
  todayNo: '0019',
  memoNo: '0215',
  marketName: '南京众彩市场',
  stallName: '标准版商行',
  buyerName: '周玉婷0001',
  buyerPhone: '138****1234',
  buyerPhoneFull: '13812345678',
  buyerAddress: '武汉四季美批发市场A区301号',
  plateNumber: '粤A12345',
  orderRemark: '拿新鲜的菜',
  deliveryTime: '2026-06-06',
  printCount: '第1次打印',
  createOrderName: '张三',
  createOrderTime: '2026-06-05 14:30',
  createName: '李四',
  createTime: '2026-06-05 14:35',
  salesManagerName: '刘铭',
  salesManagerPhone: '19870089476',
  address: '上海西郊批发市场B3105',
  stallTelephone: '15877774444',
  printTime: '2026-06-05 14:40',
  debtCutoff: '2026-06-04 19:49:37',
  customContent: '感谢惠顾，欢迎下次光临',
  depositInfo: [
    { name: '武汉九孔莲藕', qty: 1, type: '小筐', unitPrice: 20, amount: 20 },
    { name: '银耳', qty: 7, type: '大筐', unitPrice: 50, amount: 350 },
  ],
  returnBasketInfo: [
    { no: 1, name: '大筐', qty: 1, unitPrice: 50, amount: 50 },
    { no: 2, name: '中筐', qty: 3, unitPrice: 25, amount: 75 },
    { no: 3, name: '小筐', qty: 2, unitPrice: 20, amount: 40 },
  ],
  products: [
    {
      name: '武汉九孔莲藕',
      category: '',
      batch: '陈林0001',
      spec: '7件',
      orderQty: '7件',
      orderWeight: 5555,
      qty: 1,
      unit: '件',
      weight: 5555,
      weightUnit: '斤',
      grossWeight: 5560,
      tare: 5,
      price: 5,
      amount: 27775,
      freight: 4,
      deposit: { type: '小筐', qty: 1, unitPrice: 20, amount: 20 },
      productRemark: '',
    },
    {
      name: '黄豆酱',
      category: '调味品',
      batch: '',
      spec: '7罐',
      orderQty: '7罐',
      qty: 7,
      unit: '罐',
      weight: null,
      weightUnit: '',
      grossWeight: null,
      tare: null,
      price: 4,
      amount: 28,
      freight: 0,
      deposit: null,
      productRemark: '拿日期最新的',
    },
  ],
};

class StallThermalPrinterOrderEdit extends PureComponent {
  constructor(props) {
    super(props);
    const template = props.location.state?.template;
    this.state = {
      loading: !template,
      saving: false,
      template: normalizeOrderTemplate(template || {}),
      activeEditStyle: 'text_print',
      previewStyleIndex: 0,
    };
  }

  componentDidMount() {
    this.scrollPageToTop();
    const { stallId } = this.props.location.state || {};
    if (!stallId) {
      message.warning('缺少商行信息');
      this.props.history.replace('/booth/stallManager');
      return;
    }
    if (!this.props.location.state?.template) {
      this.fetchTemplate(stallId);
    }
  }

  scrollPageToTop = () => {
    window.scrollTo(0, 0);
    const layoutContent = document.querySelector('.ant-layout-content');
    if (layoutContent) layoutContent.scrollTop = 0;
  };

  fetchTemplate = async (stallId) => {
    this.setState({ loading: true });
    try {
      const res = await requestThermalPrinterOrderTemplateView({ stallId });
      if (res?.code === 200) {
        this.setState({ template: normalizeOrderTemplate(res.data || {}) });
      }
    } catch {
    } finally {
      this.setState({ loading: false });
    }
  };

  goBackToStallDetail = () => {
    const { history, location } = this.props;
    const { stallId, tab = STALL_THERMAL_PRINTER_TAB_KEY } = location.state || {};
    if (!stallId) {
      history.push('/booth/stallManager');
      return;
    }
    history.push({
      pathname: '/booth/stallManager/stallManagementDetail',
      state: { stallId },
      search: qs.stringify({ tab: String(tab) }, { addQueryPrefix: true }),
    });
  };

  setTemplate = (updater) => {
    this.setState((prev) => {
      const draft = cloneTemplate(prev.template);
      return { template: updater(draft) || draft };
    });
  };

  setSalesStyle = (styleKey) => {
    const index = SALES_STYLE_DEFS.findIndex((item) => item.key === styleKey);
    this.setState({
      activeEditStyle: styleKey,
      previewStyleIndex: index >= 0 ? index : 0,
    });
  };

  switchSalesPreviewStyle = (delta) => {
    this.setState((prev) => {
      const nextIndex =
        (prev.previewStyleIndex + delta + SALES_STYLE_DEFS.length) % SALES_STYLE_DEFS.length;
      return {
        previewStyleIndex: nextIndex,
        activeEditStyle: SALES_STYLE_DEFS[nextIndex].key,
      };
    });
  };

  updateHeaderField = (key, next) => {
    this.setTemplate((draft) => {
      draft.headList = updateFieldList(draft.headList, key, next, ORDER_HEAD_FIELDS);
    });
  };

  updateFooterField = (key, next) => {
    this.setTemplate((draft) => {
      draft.endList = updateFieldList(draft.endList, key, next, ORDER_END_FIELDS);
    });
  };

  updateProductField = (key, next) => {
    const isTextPrint = this.state.activeEditStyle === 'text_print';
    const currentProductList = isTextPrint
      ? this.state.template.textTemplate.productList
      : this.state.template.tableTemplate.productList;
    const currentSelectedField = currentProductList.find((item) => item.fieldName === key);
    const selectedCount = currentProductList.filter(
      (item) => item.printFlag && TABLE_LIMITED_PRODUCT_FIELD_KEYS.includes(item.fieldName),
    ).length;

    if (
      !isTextPrint &&
      TABLE_LIMITED_PRODUCT_FIELD_KEYS.includes(key) &&
      next.printFlag &&
      !currentSelectedField?.printFlag &&
      selectedCount >= MAX_TABLE_LIMITED_PRODUCT_FIELDS
    ) {
      message.warning(`文本表格列表字段最多勾选${MAX_TABLE_LIMITED_PRODUCT_FIELDS}个`);
      return;
    }

    this.setTemplate((draft) => {
      const productTemplate = isTextPrint ? draft.textTemplate : draft.tableTemplate;
      const productList = productTemplate.productList;
      const currentField = productList.find((item) => item.fieldName === key);
      const nextProductList = updateFieldList(productList, key, next, ORDER_PRODUCT_FIELDS);
      const linkedKeys = getOrderProductFontLinkedKeys(isTextPrint, key);
      const shouldSyncFontSize =
        linkedKeys.includes(key) && currentField && currentField.fontSize !== next.fontSize;
      const shouldSyncBoldFlag =
        linkedKeys.includes(key) && currentField && currentField.boldFlag !== next.boldFlag;

      productTemplate.productList =
        shouldSyncFontSize || shouldSyncBoldFlag
          ? nextProductList.map((item) =>
              linkedKeys.includes(item.fieldName)
                ? {
                    ...item,
                    ...(shouldSyncFontSize ? { fontSize: next.fontSize } : {}),
                    ...(shouldSyncBoldFlag ? { boldFlag: next.boldFlag } : {}),
                  }
                : item,
            )
          : nextProductList;
    });
  };

  updateTotalField = (key, next) => {
    const isTextPrint = this.state.activeEditStyle === 'text_print';
    this.setTemplate((draft) => {
      const totalTemplate = isTextPrint ? draft.textTemplate : draft.tableTemplate;
      totalTemplate.totalList = updateFieldList(
        totalTemplate.totalList,
        key,
        next,
        ORDER_TOTAL_FIELDS,
      );
    });
  };

  handleSave = async () => {
    const { stallId } = this.props.location.state || {};
    const { template, saving } = this.state;
    if (!stallId || saving) return;
    if ((template.customContent || '').length > CUSTOM_CONTENT_MAX) {
      message.error(`自定义内容最多${CUSTOM_CONTENT_MAX}个字符`);
      return;
    }

    this.setState({ saving: true });
    try {
      const userInfo = getAuthorityUserInfo();
      const res = await requestThermalPrinterOrderTemplateEdit({
        stallId,
        operatorId: getOperatorIdFromUser(userInfo),
        orderTemplateBO: template,
      });
      if (res?.code === 200) {
        message.success('保存成功');
        this.goBackToStallDetail();
      } else if (res?.msg) {
        message.error(res.msg);
      }
    } catch {
    } finally {
      this.setState({ saving: false });
    }
  };

  renderFieldGrid = (metas, list, onFieldChange) => (
    <div className='thermalFieldGrid'>
      {metas.map((meta) => (
        <ThermalPrinterFieldChip
          key={meta.key}
          meta={meta}
          value={list.find((item) => item.fieldName === meta.key)}
          onChange={(next) => onFieldChange(meta.key, next)}
        />
      ))}
    </div>
  );

  renderStyleTabs = () => {
    const { activeEditStyle } = this.state;
    return (
      <div className='thermalStyleTabs'>
        {SALES_STYLE_DEFS.map((item) => (
          <div
            key={item.key}
            className={`thermalStyleTab ${activeEditStyle === item.key ? 'active' : ''}`}
            onClick={() => this.setSalesStyle(item.key)}
          >
            {item.label}
          </div>
        ))}
      </div>
    );
  };

  renderHeaderPreview = ({ headerFields, template }) => {
    const findHeaderField = (key) => headerFields.find((item) => item.fieldName === key);
    const voucherNameField = findHeaderField('voucherName');
    const todayNoField = findHeaderField('todayNo');
    const memoNoField = findHeaderField('memoNo');
    const marketNameField = findHeaderField('marketName');
    const stallNameField = findHeaderField('stallName');
    const buyerNameField = findHeaderField('buyerName');
    const buyerPhoneField = findHeaderField('buyerPhone');
    const buyerAddressField = findHeaderField('buyerAddress');
    const plateNumberField = findHeaderField('plateNumber');
    const orderRemarkField = findHeaderField('orderRemark');
    const deliveryTimeField = findHeaderField('deliveryTime');
    const printCountField = findHeaderField('printCount');

    return (
      <>
        {voucherNameField || todayNoField || memoNoField ? (
          <div className='thermalPreviewHeaderTop'>
            <div style={voucherNameField ? getFieldStyle(voucherNameField) : null}>
              {voucherNameField ? ORDER_SAMPLE.voucherName : null}
            </div>
            <div className='thermalPreviewHeaderRight'>
              {todayNoField ? (
                <div style={getFieldStyle(todayNoField)}>票号:{ORDER_SAMPLE.todayNo}</div>
              ) : null}
              {memoNoField ? (
                <div style={getFieldStyle(memoNoField)}>码单:{ORDER_SAMPLE.memoNo}</div>
              ) : null}
            </div>
          </div>
        ) : null}
        {marketNameField ? (
          <div className='thermalPreviewLine' style={getFieldStyle(marketNameField)}>
            （{ORDER_SAMPLE.marketName}）
          </div>
        ) : null}
        {stallNameField ? (
          <div className='thermalPreviewLine' style={getFieldStyle(stallNameField)}>
            {ORDER_SAMPLE.stallName}
          </div>
        ) : null}
        {buyerNameField ? (
          <div className='thermalPreviewLine'>
            <span style={getFieldStyle(buyerNameField)}>
              客户:{ORDER_SAMPLE.buyerName}
              {template.showMasterBuyerName ? '(主买家)' : null}
            </span>
            {buyerPhoneField ? (
              <span style={getFieldStyle(buyerPhoneField)}>
                {' '}
                {template.showAllPhones ? ORDER_SAMPLE.buyerPhoneFull : ORDER_SAMPLE.buyerPhone}
              </span>
            ) : null}
          </div>
        ) : null}
        {buyerAddressField ? (
          <div className='thermalPreviewLine' style={getFieldStyle(buyerAddressField)}>
            地址:{ORDER_SAMPLE.buyerAddress}
          </div>
        ) : null}
        {plateNumberField ? (
          <div className='thermalPreviewLine' style={getFieldStyle(plateNumberField)}>
            车牌:{ORDER_SAMPLE.plateNumber}
          </div>
        ) : null}
        {orderRemarkField ? (
          <div className='thermalPreviewLine' style={getFieldStyle(orderRemarkField)}>
            备注:{ORDER_SAMPLE.orderRemark}
          </div>
        ) : null}
        {deliveryTimeField || printCountField ? (
          <div className='thermalPreviewHeaderBottom'>
            {deliveryTimeField ? (
              <span style={getFieldStyle(deliveryTimeField)}>
                送达日期:{ORDER_SAMPLE.deliveryTime}
              </span>
            ) : null}
            {printCountField ? (
              <span style={getFieldStyle(printCountField)}>{ORDER_SAMPLE.printCount}</span>
            ) : null}
          </div>
        ) : null}
      </>
    );
  };

  renderFooterPreview = ({ findFooterField, customContent }) => {
    const renderFooterLabel = (label) => <span className='thermalPreviewFooterLabel'>{label}</span>;
    const renderColon = () => <span className='thermalPreviewColon'>:</span>;
    const renderLabelLine = (field, label, value) =>
      field ? (
        <div key={field.fieldName} className='thermalPreviewLine' style={getFieldStyle(field)}>
          {renderFooterLabel(label)}
          {renderColon()}
          {value}
        </div>
      ) : null;

    const createOrderNameField = findFooterField('createOrderName');
    const createOrderTimeField = findFooterField('createOrderTime');
    const createNameField = findFooterField('createName');
    const createTimeField = findFooterField('createTime');
    const salesManagerNameField = findFooterField('salesManagerName');
    const salesManagerPhoneField = findFooterField('salesManagerPhone');
    const addressField = findFooterField('address');
    const stallTelephoneField = findFooterField('stallTelephone');
    const printTimeField = findFooterField('printTime');
    const customContentField = findFooterField('customContent');

    return (
      <>
        {createOrderNameField ? (
          <div
            key='createOrderName:createOrderTime'
            className='thermalPreviewLine'
            style={getFieldStyle(createOrderNameField)}
          >
            {renderFooterLabel('开票员')}
            {renderColon()}
            {ORDER_SAMPLE.createOrderName}
            {createOrderTimeField ? (
              <span style={{ ...getFieldStyle(createOrderTimeField), marginLeft: 8 }}>
                {ORDER_SAMPLE.createOrderTime}
              </span>
            ) : null}
          </div>
        ) : (
          renderLabelLine(createOrderTimeField, '开票时间', ORDER_SAMPLE.createOrderTime)
        )}
        {createNameField ? (
          <div
            key='createName:createTime'
            className='thermalPreviewLine'
            style={getFieldStyle(createNameField)}
          >
            {renderFooterLabel('收银员')}
            {renderColon()}
            {ORDER_SAMPLE.createName}
            {createTimeField ? (
              <span style={{ ...getFieldStyle(createTimeField), marginLeft: 8 }}>
                {ORDER_SAMPLE.createTime}
              </span>
            ) : null}
          </div>
        ) : (
          renderLabelLine(createTimeField, '收银时间', ORDER_SAMPLE.createTime)
        )}
        {salesManagerNameField ? (
          <div
            key='salesManagerName:salesManagerPhone'
            className='thermalPreviewLine'
            style={getFieldStyle(salesManagerNameField)}
          >
            {renderFooterLabel('销售经理')}
            {renderColon()}
            {ORDER_SAMPLE.salesManagerName}
            {salesManagerPhoneField ? (
              <span style={{ ...getFieldStyle(salesManagerPhoneField), marginLeft: 8 }}>
                （{ORDER_SAMPLE.salesManagerPhone}）
              </span>
            ) : null}
          </div>
        ) : null}
        {renderLabelLine(addressField, '商行地址', ORDER_SAMPLE.address)}
        {renderLabelLine(stallTelephoneField, '联系方式', ORDER_SAMPLE.stallTelephone)}
        {renderLabelLine(printTimeField, '打印时间', ORDER_SAMPLE.printTime)}
        {customContentField && customContent ? (
          <div
            key='customContent'
            className='thermalPreviewLine'
            style={getFieldStyle(customContentField)}
          >
            {customContent}
          </div>
        ) : null}
      </>
    );
  };

  renderTextProductPreview = ({
    productFields,
    totalNumberWeightField,
    template,
    formatPrice,
    formatAmount,
    formatWeight,
    underlineStyle,
  }) => {
    const findProductField = (key) => productFields.find((item) => item.fieldName === key);
    const productNameField = findProductField('productName');
    const subtotalField = findProductField('subtotal');
    const basketField = findProductField('basketDesc');
    const remarkField = findProductField('productRemark');
    const makeProductName = (item) => {
      const suffix = template.showBatchCategory
        ? [item.batch, item.category]
            .filter(Boolean)
            .map((text) => `(${text})`)
            .join('')
        : '';
      return `${item.name}${suffix}`;
    };
    const buildDetails = (item) => {
      const details = [];
      const orderNumberField = findProductField('orderNumber');
      const saleNumberField = findProductField('saleNumber');
      const packWeightField = findProductField('packWeight');
      const grossWeightField = findProductField('grossWeight');
      const unitPriceField = findProductField('unitPrice');
      const extraAmountField = findProductField('extraAmount');
      const goodsAmountField = findProductField('goodsAmount');

      if (orderNumberField) {
        if (item.orderQty)
          details.push({ text: `下单数量:${item.orderQty}`, field: orderNumberField });
        if (item.orderWeight)
          details.push({
            text: `下单重量:${formatWeight(item.orderWeight, item.weightUnit)}`,
            field: orderNumberField,
          });
      }
      if (saleNumberField) {
        if (item.qty)
          details.push({ text: `数量:${item.qty}${item.unit || ''}`, field: saleNumberField });
        if (item.weight) {
          details.push({
            text: `重量:${formatWeight(item.weight, item.weightUnit)}`,
            field: saleNumberField,
          });
        }
      }
      if (packWeightField && item.spec)
        details.push({ text: `规格:${item.spec}`, field: packWeightField });
      if (grossWeightField && item.grossWeight) {
        details.push({
          text: `毛重:${formatWeight(item.grossWeight, item.weightUnit)}`,
          field: grossWeightField,
        });
      }
      if (grossWeightField && item.tare) {
        details.push({
          text: `去皮:${formatWeight(item.tare, item.weightUnit)}`,
          field: grossWeightField,
        });
      }
      if (unitPriceField) {
        details.push({
          text: `单价:${formatPrice(item.price, item.unit)}`,
          field: unitPriceField,
        });
      }
      if (extraAmountField) {
        if (item.freight)
          details.push({ text: `力资费:${formatAmount(item.freight)}`, field: extraAmountField });
        if (item.basketFee)
          details.push({
            text: `灌包费:${formatAmount(item.basketFee)}`,
            field: extraAmountField,
          });
        if (item.invoiceFee)
          details.push({
            text: `开票费:${formatAmount(item.invoiceFee)}`,
            field: extraAmountField,
          });
      }
      if (goodsAmountField && item.amount) {
        details.push({
          text: `货款:${formatAmount(
            item.amount - (item.freight || 0) - (item.basketFee || 0) - (item.invoiceFee || 0),
          )}`,
          field: goodsAmountField,
        });
      }
      return details;
    };
    const renderDetailGrid = (details) =>
      details.length ? (
        <div className='thermalPreviewDetailGrid'>
          {details.map((detail, index) => (
            <span key={`${detail.text}:${index}`} style={getFieldStyle(detail.field)}>
              {detail.text}
            </span>
          ))}
        </div>
      ) : null;

    const renderUnderlinedProductTable = () => (
      <table className='thermalPreviewTable'>
        <tbody>
          <tr>
            <td colSpan={3} style={{ borderBottom: '1px dashed #000' }}>
              <div className='thermalPreviewBasketTitle '>货品信息</div>
            </td>
          </tr>
          {ORDER_SAMPLE.products.map((item, index) => {
            const details = buildDetails(item);
            return (
              <React.Fragment key={item.name}>
                {productNameField ? (
                  <tr>
                    <td colSpan={subtotalField ? 2 : 3} style={underlineStyle}>
                      <span className='thermalPreviewProductName' style={getFieldStyle(productNameField)}>
                        {index + 1}.{makeProductName(item)}
                      </span>
                    </td>
                    {subtotalField ? (
                      <td style={underlineStyle}>
                        <span
                          className='thermalPreviewProductSubtotal'
                          style={{ ...getFieldStyle(subtotalField), textAlign: 'left' }}
                        >
                          小计:{formatAmount(item.amount)}
                        </span>
                      </td>
                    ) : null}
                  </tr>
                ) : null}
                {Array.from({ length: Math.ceil(details.length / 3) }).map((_, rowIndex) => (
                  <tr key={`${item.name}:detail:${rowIndex}`}>
                    {[0, 1, 2].map((columnIndex) => {
                      const detail = details[rowIndex * 3 + columnIndex];
                      return (
                        <td key={columnIndex} style={underlineStyle}>
                          {detail ? (
                            <span style={getFieldStyle(detail.field)}>{detail.text}</span>
                          ) : null}
                        </td>
                      );
                    })}
                  </tr>
                ))}
                {basketField && item.deposit ? (
                  <>
                    <tr>
                      <td colSpan={2} style={underlineStyle}>
                        <span className='thermalPreviewProductName' style={getFieldStyle(basketField)}>
                          {item.deposit.type}
                        </span>
                      </td>
                      <td style={underlineStyle}>
                        <span
                          className='thermalPreviewProductSubtotal'
                          style={{ ...getFieldStyle(basketField), textAlign: 'left' }}
                        >
                          小计:{formatAmount(item.deposit.amount)}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td style={underlineStyle}>
                        <span style={getFieldStyle(basketField)}>数量:{item.deposit.qty}个</span>
                      </td>
                      <td style={underlineStyle}>
                        <span style={getFieldStyle(basketField)}>
                          单价:{formatAmount(item.deposit.unitPrice)}
                        </span>
                      </td>
                      <td style={underlineStyle}>
                        <span style={getFieldStyle(basketField)}>
                          金额:{formatAmount(item.deposit.amount)}
                        </span>
                      </td>
                    </tr>
                  </>
                ) : null}
                {remarkField && item.productRemark ? (
                  <tr>
                    <td colSpan={3} style={underlineStyle}>
                      <span style={getFieldStyle(remarkField)}>备注:{item.productRemark}</span>
                    </td>
                  </tr>
                ) : null}
              </React.Fragment>
            );
          })}
          {totalNumberWeightField ? (
            <tr>
              <td colSpan={3} className='thermalPreviewTextTableTotal' style={underlineStyle}>
                <span style={getFieldStyle(totalNumberWeightField)}>
                  总数:8　总重:5562　合计:{formatAmount(27803)}
                </span>
              </td>
            </tr>
          ) : null}
        </tbody>
      </table>
    );

    return template.globalUnderline ? (
      renderUnderlinedProductTable()
    ) : (
      <div>
        <div className='thermalPreviewSectionTitle' style={{ borderBottom: '1px dashed #000' }}>
          货品信息
        </div>
        {ORDER_SAMPLE.products.map((item, index) => (
          <div key={item.name} className='thermalPreviewItemBlock' style={underlineStyle}>
            {productNameField ? (
              <div className='thermalPreviewProductTitleRow'>
                <span className='thermalPreviewProductName' style={getFieldStyle(productNameField)}>
                  {index + 1}.{makeProductName(item)}
                </span>
                {subtotalField ? (
                  <span
                    className='thermalPreviewProductSubtotal'
                    style={{ ...getFieldStyle(subtotalField), textAlign: 'left' }}
                  >
                    小计:{formatAmount(item.amount)}
                  </span>
                ) : null}
              </div>
            ) : null}
            {renderDetailGrid(buildDetails(item))}
            {basketField && item.deposit ? (
              <>
                <div className='thermalPreviewProductTitleRow thermalPreviewDepositTitle'>
                  <span className='thermalPreviewProductName' style={getFieldStyle(basketField)}>
                    {item.deposit.type}
                  </span>
                  <span
                    className='thermalPreviewProductSubtotal'
                    style={{ ...getFieldStyle(basketField), textAlign: 'left' }}
                  >
                    小计:{formatAmount(item.deposit.amount)}
                  </span>
                </div>
                <div className='thermalPreviewDetailGrid'>
                  <span style={getFieldStyle(basketField)}>数量:{item.deposit.qty}个</span>
                  <span style={getFieldStyle(basketField)}>
                    单价:{formatAmount(item.deposit.unitPrice)}
                  </span>
                  <span style={getFieldStyle(basketField)}>
                    金额:{formatAmount(item.deposit.amount)}
                  </span>
                </div>
              </>
            ) : null}
            {basketField && item.basketDesc ? (
              <div className='thermalPreviewDetailGrid'>
                <span style={getFieldStyle(basketField)}>{item.basketDesc}</span>
              </div>
            ) : null}
            {remarkField && item.productRemark ? (
              <div className='thermalPreviewLine' style={getFieldStyle(remarkField)}>
                备注:{item.productRemark}
              </div>
            ) : null}
          </div>
        ))}
        {totalNumberWeightField ? (
          <div
            className='thermalPreviewTextTotal'
            style={{ ...getFieldStyle(totalNumberWeightField), textAlign: 'right' }}
          >
            总数:8　总重:5562　合计:{formatAmount(27803)}
          </div>
        ) : null}
      </div>
    );
  };

  renderTableProductPreview = ({
    productFields,
    totalNumberWeightField,
    template,
    formatPrice,
    formatAmount,
    formatWeight,
    underlineStyle,
  }) => {
    const findProductField = (key) => productFields.find((item) => item.fieldName === key);
    const mainKeys = [
      'productName',
      'packWeight',
      'orderNumber',
      'saleNumber',
      'unitPrice',
      'goodsAmount',
      'subtotal',
    ];
    const columnClassMap = {
      productName: 'goods',
      packWeight: 'spec',
      orderNumber: 'order',
      saleNumber: 'qty',
      unitPrice: 'price',
      goodsAmount: 'amount',
      subtotal: 'subtotal',
    };
    const mainFields = mainKeys.map((key) => findProductField(key)).filter(Boolean);
    const grossWeightField = findProductField('grossWeight');
    const extraAmountField = findProductField('extraAmount');
    const basketField = findProductField('basketDesc');
    const remarkField = findProductField('productRemark');
    const makeProductName = (item, index) => {
      const suffix = template.showBatchCategory
        ? [item.batch, item.category]
            .filter(Boolean)
            .map((text) => `(${text})`)
            .join('')
        : '';
      return `${index + 1}.${item.name}${suffix}`;
    };
    const renderColumns = (renderValue, className = '', getStyle = getFieldStyle) => (
      <div className={`thermalPreviewFlexRow ${className}`} style={underlineStyle}>
        {mainFields.map((field) => {
          const value = renderValue(field);
          return (
            <span
              key={field.fieldName}
              className={`thermalPreviewFlexCell ${columnClassMap[field.fieldName] || ''}`}
              style={getStyle(field)}
            >
              {value}
            </span>
          );
        })}
      </div>
    );
    const renderOffsetRow = (field, targetKey, value, fillRemaining = false) => {
      if (!field || !mainFields.find((item) => item.fieldName === targetKey) || !value) return null;
      const targetIndex = mainFields.findIndex((item) => item.fieldName === targetKey);
      const columnFlexMap = {
        productName: 2.5,
        packWeight: 0.8,
        orderNumber: 1,
        saleNumber: 1,
        unitPrice: 0.8,
        goodsAmount: 1,
        subtotal: 1.2,
      };
      const remainingFlex = mainFields
        .slice(targetIndex)
        .reduce((total, item) => total + (columnFlexMap[item.fieldName] || 1), 0);
      return (
        <div className='thermalPreviewFlexRow' style={underlineStyle}>
          {mainFields.map((item, index) => {
            if (fillRemaining && index > targetIndex) return null;
            const isTarget = item.fieldName === targetKey;
            return (
              <span
                key={`${field.fieldName}:${item.fieldName}`}
                className={`thermalPreviewFlexCell ${columnClassMap[item.fieldName] || ''}`}
                style={
                  isTarget
                    ? {
                        ...getFieldStyle(field),
                        ...(fillRemaining ? { flex: `${remainingFlex} 1 0` } : {}),
                      }
                    : null
                }
              >
                {isTarget ? value : null}
              </span>
            );
          })}
        </div>
      );
    };

    const totalQty = ORDER_SAMPLE.products.reduce((sum, item) => sum + (item.qty || 0), 0);
    const totalWeight = ORDER_SAMPLE.products.reduce((sum, item) => sum + (item.weight || 0), 0);
    const itemTotal = ORDER_SAMPLE.products.reduce((sum, item) => sum + (item.amount || 0), 0);

    return (
      <div className='thermalPreviewFlexTable'>
        {!template.globalUnderline ? <div className='thermalPreviewDivider' /> : null}
        {renderColumns(
          (field) => {
            const meta = ORDER_PRODUCT_FIELDS.find((item) => item.key === field.fieldName);
            return meta?.label;
          },
          'isHeader',
          (field) => ({
            ...getFieldStyle(template.tableTemplate.tableHead),
            textAlign: field.align || 'left',
          }),
        )}
        {ORDER_SAMPLE.products.map((item, index) => {
          const goodsAmount =
            item.amount - (item.freight || 0) - (item.basketFee || 0) - (item.invoiceFee || 0);
          const qtyText = item.weight
            ? formatWeight(item.weight, item.weightUnit)
            : `${item.qty || '-'}${item.unit || ''}`;
          const fees = [];
          if (item.freight) fees.push(`力资费:${formatAmount(item.freight)}`);
          if (item.basketFee) fees.push(`灌包费:${formatAmount(item.basketFee)}`);
          if (item.invoiceFee) fees.push(`开票费:${formatAmount(item.invoiceFee)}`);
          return (
            <React.Fragment key={item.name}>
              {renderColumns((field) => {
                const valueMap = {
                  productName: makeProductName(item, index),
                  packWeight: item.spec || '-',
                  orderNumber: item.orderQty || '-',
                  saleNumber: qtyText,
                  unitPrice: formatPrice(item.price, item.unit),
                  goodsAmount: formatAmount(goodsAmount),
                  subtotal: formatAmount(item.amount),
                };
                return valueMap[field.fieldName] || null;
              })}
              {renderOffsetRow(
                grossWeightField,
                'saleNumber',
                item.grossWeight
                  ? `(${[
                      `${formatWeight(item.grossWeight, item.weightUnit)}`,
                      item.tare ? `${formatWeight(item.tare, item.weightUnit)}` : '',
                    ]
                      .filter(Boolean)
                      .join('-')})`
                  : null,
                true,
              )}
              {extraAmountField && fees.length ? (
                <div
                  className='thermalPreviewFullRow'
                  style={{ ...getFieldStyle(extraAmountField), ...underlineStyle }}
                >
                  {fees.join('　')}
                </div>
              ) : null}
              {basketField && item.deposit
                ? renderColumns((field) => {
                    const valueMap = {
                      productName: item.deposit.type,
                      saleNumber: `${item.deposit.qty}个`,
                      unitPrice: formatAmount(item.deposit.unitPrice),
                      subtotal: formatAmount(item.deposit.amount),
                    };
                    return valueMap[field.fieldName] || null;
                  })
                : null}
              {remarkField && item.productRemark ? (
                <div
                  className='thermalPreviewFullRow'
                  style={{ ...getFieldStyle(remarkField), ...underlineStyle }}
                >
                  备注:{item.productRemark}
                </div>
              ) : null}
            </React.Fragment>
          );
        })}
        {totalNumberWeightField ? (
          <div
            className='thermalPreviewFlexRow isTotal'
            style={{ ...getFieldStyle(totalNumberWeightField), ...underlineStyle }}
          >
            {mainFields.map((field) => {
              const valueMap = {
                productName: '合计',
                saleNumber: (
                  <>
                    {totalQty}
                    <br />
                    {totalWeight}
                  </>
                ),
                subtotal: formatAmount(itemTotal),
              };
              return (
                <span
                  key={`total:${field.fieldName}`}
                  className={`thermalPreviewFlexCell ${columnClassMap[field.fieldName] || ''}`}
                >
                  {valueMap[field.fieldName] || null}
                </span>
              );
            })}
          </div>
        ) : null}
      </div>
    );
  };

  renderBasketSummarySection = ({ field, type, formatAmount, underlineStyle }) => {
    const isDeposit = type === 'deposit';
    const title = isDeposit ? '押筐信息' : '收筐:2026-08-18 14:47';
    const rows = isDeposit ? ORDER_SAMPLE.depositInfo : ORDER_SAMPLE.returnBasketInfo;
    if (!field || !rows?.length) return null;
    const total = rows.reduce((sum, item) => sum + (item.amount || 0), 0);
    const baseStyle = getFieldStyle(field);
    const basketTextStyle = {
      fontSize: baseStyle.fontSize,
      fontWeight: baseStyle.fontWeight,
    };
    const basketTitleStyle = { ...basketTextStyle, fontWeight: 700 };
    const basketHeaderStyle = { ...basketTextStyle, fontWeight: 700 };

    return (
      <div className='thermalPreviewBasketSummary' style={baseStyle}>
        <div
          className={`thermalPreviewBasketTitle isUnderlined`}
          style={{ ...basketTitleStyle, ...underlineStyle }}
        >
          {title}
        </div>
        <div
          className='thermalPreviewBasketRow isHeader'
          style={{ ...basketHeaderStyle, ...underlineStyle }}
        >
          {isDeposit ? <span className='goods'>货品</span> : null}
          <span className='type'>类型</span>
          <span>数量</span>
          <span>单价</span>
          <span>金额</span>
        </div>
        {rows.map((item) => (
          <div
            key={isDeposit ? `${item.name}:${item.type}` : `${item.no}:${item.name}`}
            className='thermalPreviewBasketRow'
            style={{ ...basketTextStyle, ...underlineStyle }}
          >
            {isDeposit ? <span className='goods'>{item.name}</span> : null}
            <span className='type'>{isDeposit ? item.type : `${item.no} ${item.name}`}</span>
            <span>{item.qty}个</span>
            <span>{formatAmount(item.unitPrice)}</span>
            <span>{formatAmount(item.amount)}</span>
          </div>
        ))}
        <div className='thermalPreviewBasketTotal' style={basketTextStyle}>
          合计:{formatAmount(total)}
        </div>
      </div>
    );
  };

  renderPreview = () => {
    const { template, activeEditStyle, previewStyleIndex } = this.state;
    const headerFields = template.headList.filter((item) => item.printFlag);
    const productSource =
      activeEditStyle === 'text_print'
        ? template.textTemplate.productList
        : template.tableTemplate.productList;
    const totalSource =
      activeEditStyle === 'text_print'
        ? template.textTemplate.totalList
        : template.tableTemplate.totalList;
    const productFields = productSource.filter((item) => item.printFlag);
    const totalFields = totalSource.filter((item) => item.printFlag);
    const totalNumberWeightField = totalFields.find(
      (item) => item.fieldName === 'totalNumberWeight',
    );
    const previewTotalFields = totalFields.filter((item) => item.fieldName !== 'totalNumberWeight');
    const footerFields = template.endList.filter((item) => item.printFlag);
    const findFooterField = (key) => footerFields.find((item) => item.fieldName === key);
    const underlineStyle = template.globalUnderline ? { borderBottom: '1px dashed #000' } : null;
    const styleDef = SALES_STYLE_DEFS[previewStyleIndex] || SALES_STYLE_DEFS[0];
    const formatAmount = (amount) => `${amount}${template.showAmountUnit ? '元' : ''}`;
    const formatWeight = (weight, unit = '斤') => `${weight}${template.showWeightUnit ? unit : ''}`;
    const formatPrice = (price, unit) =>
      template.showPriceUnit ? `${price}元/${unit}` : String(price);
    const paymentAmountDetails = [
      `${formatAmount(1000)}(现金)`,
      `${formatAmount(4000)}(支付宝)`,
      `${formatAmount(165)}(收筐抵扣)`,
    ];
    const totalValueMap = {
      depositBasketAmount: formatAmount(370),
      returnBasketAmount: formatAmount(165),
      totalGoodsAmount: formatAmount(27803),
      totalAmount: formatAmount(27903),
      discountAmount: formatAmount(10),
      payableAmount: formatAmount(27903),
      refundAmount: formatAmount(100),
      deductCreditAmount: formatAmount(50),
      actualRefundAmount: `${formatAmount(50)}(现金)`,
      currentDebtAmount: formatAmount(29782),
      prestoreBalance: formatAmount(200),
      beforeCreditAmount: formatAmount(1200),
      buyerCreditAmount: formatAmount(24103),
    };
    const basketTotalFields = previewTotalFields.filter((field) =>
      ['depositBasketAmount', 'returnBasketAmount'].includes(field.fieldName),
    );
    const debtTotalFields = previewTotalFields.filter((field) =>
      ['prestoreBalance', 'beforeCreditAmount', 'buyerCreditAmount'].includes(field.fieldName),
    );
    const financialTotalFields = previewTotalFields.filter(
      (field) =>
        ![
          'depositBasketAmount',
          'returnBasketAmount',
          'prestoreBalance',
          'beforeCreditAmount',
          'buyerCreditAmount',
        ].includes(field.fieldName),
    );
    const renderTotalField = (field) => {
      const meta = ORDER_TOTAL_FIELDS.find((item) => item.key === field.fieldName);
      if (field.fieldName === 'chargeOrderFee') {
        return (
          <React.Fragment key={field.fieldName}>
            <div className='thermalPreviewLine' style={getFieldStyle(field)}>
              <span className='thermalPreviewSummaryLabel'>{meta?.label}</span>
              <span className='thermalPreviewColon'>:</span>
              {formatAmount(100)}
            </div>
            <div className='thermalPreviewLine' style={getFieldStyle(field)}>
              <span className='thermalPreviewSummaryLabel'>备注</span>
              <span className='thermalPreviewColon'>:</span>
              三楼送货费
            </div>
          </React.Fragment>
        );
      }
      const displayValue = totalValueMap[field.fieldName] || formatAmount(27803);
      let label = meta?.label;
      if (field.fieldName === 'discountAmount') {
        label = '总优惠';
      }
      if (field.fieldName === 'paymentAmount') {
        return (
          <div
            key={field.fieldName}
            className='thermalPreviewLine thermalPreviewPaymentAmount'
            style={getFieldStyle(field)}
          >
            <span className='thermalPreviewPaymentAmountContent'>
              <span className='thermalPreviewSummaryLabel'>{label}</span>
              <span className='thermalPreviewColon'>:</span>
              <span className='thermalPreviewPaymentAmountDetails'>
                {paymentAmountDetails.map((item) => (
                  <span key={item}>{item}</span>
                ))}
              </span>
            </span>
          </div>
        );
      }
      return (
        <div key={field.fieldName} className='thermalPreviewLine' style={getFieldStyle(field)}>
          <span className='thermalPreviewSummaryLabel'>{label}</span>
          <span className='thermalPreviewColon'>:</span>
          {displayValue}
        </div>
      );
    };
    return (
      <div className='thermalPreviewPaper'>
        <div className='thermalPreviewNav'>
          <button
            type='button'
            className='thermalPreviewNavBtn'
            onClick={() => this.switchSalesPreviewStyle(-1)}
          >
            ◀
          </button>
          <span className='thermalPreviewNavLabel'>
            {styleDef.label} {previewStyleIndex + 1}/{SALES_STYLE_DEFS.length}
          </span>
          <button
            type='button'
            className='thermalPreviewNavBtn'
            onClick={() => this.switchSalesPreviewStyle(1)}
          >
            ▶
          </button>
        </div>
        {this.renderHeaderPreview({ headerFields, template })}
        {activeEditStyle === 'text_print'
          ? this.renderTextProductPreview({
              productFields,
              totalNumberWeightField,
              template,
              formatPrice,
              formatAmount,
              formatWeight,
              underlineStyle,
            })
          : this.renderTableProductPreview({
              productFields,
              totalNumberWeightField,
              template,
              formatPrice,
              formatAmount,
              formatWeight,
              underlineStyle,
            })}
        {basketTotalFields.map((field) => {
          if (field.fieldName === 'depositBasketAmount') {
            return (
              <React.Fragment key={field.fieldName}>
                {this.renderBasketSummarySection({
                  field,
                  type: 'deposit',
                  formatAmount,
                  underlineStyle,
                })}
              </React.Fragment>
            );
          }
          if (field.fieldName === 'returnBasketAmount') {
            return (
              <React.Fragment key={field.fieldName}>
                {this.renderBasketSummarySection({
                  field,
                  type: 'return',
                  formatAmount,
                  underlineStyle,
                })}
              </React.Fragment>
            );
          }
        })}
        {financialTotalFields.length && !template.globalUnderline ? (
          <div className='thermalPreviewDivider' />
        ) : null}
        {financialTotalFields.map(renderTotalField)}
        {template.showTraceability ? (
          <>
            <div className='thermalPreviewDivider' />
            <div className='thermalTraceabilityLine'>客户签字:</div>
            <div className='thermalTraceabilityLine'>（√）已查验承诺达标合格证</div>
            <div className='thermalTraceabilityLine'>（　）已抽样检验或者快速检测</div>
          </>
        ) : null}
        {debtTotalFields.length ? (
          <>
            <div className='thermalPreviewDivider' />
            <div className='thermalPreviewDebtCutoff'>
              截止 {ORDER_SAMPLE.debtCutoff} 您在本商行:
            </div>
            {debtTotalFields.map(renderTotalField)}
          </>
        ) : null}
        <div className='thermalPreviewDivider' />
        {template.showHandwriteArea ? (
          <>
            {Array.from({ length: template.handwriteRows || 1 }).map((_, index) => (
              <div key={index} className='thermalPreviewHandwriteLine' style={underlineStyle}>
                &nbsp;
              </div>
            ))}
          </>
        ) : null}
        {this.renderFooterPreview({
          findFooterField,
          customContent: template.customContent,
        })}
      </div>
    );
  };

  render() {
    const { loading, saving, template, activeEditStyle } = this.state;
    const productList =
      activeEditStyle === 'text_print'
        ? template.textTemplate.productList
        : template.tableTemplate.productList;
    const totalList =
      activeEditStyle === 'text_print'
        ? template.textTemplate.totalList
        : template.tableTemplate.totalList;
    const customContentField = template.endList.find((item) => item.fieldName === 'customContent');
    return (
      <PageHeaderLayout>
        <div className='StallManagementDetail'>
          <div className='thermalPrinterEditPage'>
            <div className='thermalEditTitle'>
              编辑销售单模板
              <span className='thermalEditHint'>
                新模板的字体大小对旧的思普瑞特打印机不生效，对旧的皇胜打印机生效
              </span>
            </div>
            <Spin spinning={loading}>
              <div className='thermalEditLayout'>
                <div className='thermalEditMain'>
                  <div className='thermalSection'>
                    <div className='thermalSectionTitle'>表头字段</div>
                    {this.renderFieldGrid(
                      ORDER_HEAD_FIELDS,
                      template.headList,
                      this.updateHeaderField,
                    )}
                  </div>

                  <div className='thermalSection'>
                    <div className='thermalSectionTitle'>货品样式</div>
                    {this.renderStyleTabs()}
                    <Space direction='vertical' style={{ width: '100%' }} size={12}>
                      {activeEditStyle === 'custom_style' ? (
                        <ThermalPrinterTableHeadEditor
                          value={template.tableTemplate.tableHead}
                          onChange={(next) =>
                            this.setTemplate((draft) => {
                              draft.tableTemplate.tableHead = next;
                            })
                          }
                        />
                      ) : null}
                      <div>货品</div>
                      {this.renderFieldGrid(
                        ORDER_VISIBLE_PRODUCT_FIELDS,
                        productList,
                        this.updateProductField,
                      )}
                      <div>合计</div>
                      {this.renderFieldGrid(ORDER_TOTAL_FIELDS, totalList, this.updateTotalField)}
                    </Space>
                  </div>

                  <div className='thermalSection'>
                    <div className='thermalSectionTitle'>表尾字段</div>
                    {this.renderFieldGrid(
                      ORDER_END_FIELDS,
                      template.endList,
                      this.updateFooterField,
                    )}
                    {customContentField?.printFlag ? (
                      <Input.TextArea
                        style={{ marginTop: 12 }}
                        rows={3}
                        maxLength={CUSTOM_CONTENT_MAX}
                        showCount
                        placeholder='请输入自定义内容，最多200字'
                        value={template.customContent}
                        onChange={(e) =>
                          this.setTemplate((draft) => {
                            draft.customContent = e.target.value;
                          })
                        }
                      />
                    ) : null}
                  </div>

                  <div className='thermalSection'>
                    <div className='thermalSectionTitle'>其他配置</div>
                    <div className='thermalSwitchGrid'>
                      <div className='thermalSwitchRow'>
                        <span>重量单位</span>
                        <Switch
                          checked={template.showWeightUnit}
                          onChange={(checked) =>
                            this.setTemplate((draft) => {
                              draft.showWeightUnit = checked;
                            })
                          }
                        />
                      </div>
                      <div className='thermalSwitchRow'>
                        <span>单价单位</span>
                        <Switch
                          checked={template.showPriceUnit}
                          onChange={(checked) =>
                            this.setTemplate((draft) => {
                              draft.showPriceUnit = checked;
                            })
                          }
                        />
                      </div>
                      <div className='thermalSwitchRow'>
                        <span>金额单位</span>
                        <Switch
                          checked={template.showAmountUnit}
                          onChange={(checked) =>
                            this.setTemplate((draft) => {
                              draft.showAmountUnit = checked;
                            })
                          }
                        />
                      </div>
                      <div className='thermalSwitchRow'>
                        <span>加下划线</span>
                        <Switch
                          checked={template.globalUnderline}
                          onChange={(checked) =>
                            this.setTemplate((draft) => {
                              draft.globalUnderline = checked;
                            })
                          }
                        />
                      </div>
                      <div className='thermalSwitchRow'>
                        <span>显示定装货品重量</span>
                        <Switch
                          checked={template.showFixedWeight}
                          onChange={(checked) =>
                            this.setTemplate((draft) => {
                              draft.showFixedWeight = checked;
                            })
                          }
                        />
                      </div>
                      <div className='thermalSwitchRow'>
                        <span>显示非定装货品重量</span>
                        <Switch
                          checked={template.showNonFixedWeight}
                          onChange={(checked) =>
                            this.setTemplate((draft) => {
                              draft.showNonFixedWeight = checked;
                            })
                          }
                        />
                      </div>
                      <div className='thermalSwitchRow'>
                        <span>显示客户全部电话</span>
                        <Switch
                          checked={template.showAllPhones}
                          onChange={(checked) =>
                            this.setTemplate((draft) => {
                              draft.showAllPhones = checked;
                            })
                          }
                        />
                      </div>
                      <div className='thermalSwitchRow'>
                        <span>溯源信息</span>
                        <Switch
                          checked={template.showTraceability}
                          onChange={(checked) =>
                            this.setTemplate((draft) => {
                              draft.showTraceability = checked;
                            })
                          }
                        />
                      </div>
                      <div className='thermalSwitchRow'>
                        <span>显示批次/货品分类</span>
                        <Switch
                          checked={template.showBatchCategory}
                          onChange={(checked) =>
                            this.setTemplate((draft) => {
                              draft.showBatchCategory = checked;
                            })
                          }
                        />
                      </div>
                      <div className='thermalSwitchStack'>
                        <div className='thermalSwitchRow'>
                          <span className='thermalSwitchRowLabel'>
                            加手写区域
                            {template.showHandwriteArea ? (
                              <div className='thermalInputRow thermalSwitchSubRow'>
                                <span>空行数量</span>
                                <ThermalPrinterNumberInput
                                  value={template.handwriteRows}
                                  onChange={(value) =>
                                    this.setTemplate((draft) => {
                                      draft.handwriteRows = value;
                                    })
                                  }
                                />
                              </div>
                            ) : null}
                          </span>
                          <Switch
                            checked={template.showHandwriteArea}
                            onChange={(checked) =>
                              this.setTemplate((draft) => {
                                draft.showHandwriteArea = checked;
                              })
                            }
                          />
                        </div>
                      </div>
                      <div className='thermalSwitchRow'>
                        <span>显示关联主买家</span>
                        <Switch
                          aria-label='显示关联主买家'
                          checked={template.showMasterBuyerName}
                          onChange={(checked) =>
                            this.setTemplate((draft) => {
                              draft.showMasterBuyerName = checked;
                            })
                          }
                        />
                      </div>
                    </div>
                  </div>

                  <div className='thermalEditFooter'>
                    <Button onClick={this.goBackToStallDetail}>取消</Button>
                    <Button type='primary' loading={saving} onClick={this.handleSave}>
                      保存
                    </Button>
                  </div>
                </div>
                <div className='thermalPreviewPanel'>{this.renderPreview()}</div>
              </div>
            </Spin>
          </div>
        </div>
      </PageHeaderLayout>
    );
  }
}

export default StallThermalPrinterOrderEdit;
